<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">Unidades de Acolhimento</h1>
    </div>
    <div class="col-md-12">
      <div class="card mb-0 shadow">
        <div class="card-body">
          <div class="tab-content">
            <div class="animate__animated animate__fadeIn">
              <div class="row">
                <div class="col-12">
                  <div
                    class="d-flex align-items-center justify-content-between mb-4"
                    v-show="loading == false"
                  >
                    <div>
                      <button
                        v-if="isGestor"
                        class="btn btn-primary"
                        @click="openCadastrar"
                      >
                        <i class="fas fa-plus-square" />
                        {{ $t("Cadastrar Vagas") }}
                      </button>

                      <button
                        class="btn btn-secondary"
                        @click="openSolicitarVagas"
                      >
                        <i class="fas fa-folder-open" />
                        {{ $t("Solicitar vagas") }}
                      </button>

                      <button
                        class="btn btn-warning text-dark"
                        @click="abrirGestaoVagas"
                      >
                        <i class="fas fa-tasks"></i>
                        {{ $t("Gestão e Acompanhamento de Vagas") }}
                      </button>
                    </div>
                    <div>
                      <b-button-group>
                        <b-button
                          variant="outline-dark"
                          :class="viewFilterReport === true ? 'active' : ''"
                          @click="viewFilters"
                        >
                          <i class="fas fa-filter"></i>
                          {{ $t("Filtros") }}
                        </b-button>
                        <b-button variant="outline-dark" @click="print()">
                          <i class="fas fa-print"></i>
                        </b-button>
                        <b-button
                          variant="outline-dark"
                          @click="exportar()"
                          :title="$t('Exportar')"
                          v-b-tooltip.hover
                        >
                          <i class="fas fa-file-excel"></i>
                        </b-button>
                      </b-button-group>
                    </div>
                  </div>
                </div>
                <FiltroHeader
                  v-show="viewFilterReport"
                  @clearfiltro="viewFilterReport = false"
                  @getitens="getItensFromFirstPage"
                  @setvalues="setValues"
                />
              </div>

              <load v-if="loading" mode="table" />
              <div class="row" v-show="!loading">
                <div class="col-md-12">
                  <print-content>
                    <b-table
                      :fields="[
                        {
                          key: 'unidade_nome',
                          label: $t('Nome'),
                        },
                        {
                          key: 'publico_alvo',
                          label: $t('Público-alvo'),
                        },
                        {
                          key: 'vagas_disponiveis',
                          label: $t('Vagas Disponíveis'),
                        },
                        {
                          key: 'vagas_ocupadas',
                          label: $t('Vagas Ocupadas'),
                        },
                        {
                          key: 'actions',
                          label: '',
                          class: 'text-right no-print',
                          thStyle: {
                            width: '95px',
                            minWidth: '95px',
                          },
                        },
                      ]"
                      :items="itemList"
                      :responsive="true"
                      striped
                      hover
                      show-empty
                      small
                      outlined
                      stacked="xs"
                      table-class="mb-3"
                    >
                      <template v-slot:cell(unidade_nome)="data">
                        <b>{{ data.item.unidade_nome }}</b>
                      </template>
                      <template v-slot:cell(publico_alvo)="data">
                        <strong
                          v-for="(publico, i) in data.item.publico_alvo"
                          :key="i"
                          v-html="
                            getPublicoAlvo(
                              publico,
                              $root.arrays.acolhimento_publico_alvo
                            )
                          "
                        >
                        </strong>
                      </template>
                      <!-- <template v-slot:cell(subtipo)="data">
                        {{ data.item.unidade.subtipo_nome }}
                      </template> -->
                      <template v-slot:cell(vagas_disponiveis)="data">
                        {{ data.item.vagas_disponiveis }}
                      </template>
                      <template v-slot:cell(vagas_ocupadas)="data">
                        {{ data.item.vagas_ocupadas }}
                      </template>
                      <template v-slot:cell()="data">
                        <div class="d-flex flex-nowrap align-items-center justify-content-end" style="gap: 4px; max-width: 100%;">
                          <button
                            v-if="isGestor"
                            :title="$t('Editar')"
                            @click="editar(data.item)"
                            class="btn btn-primary btn-xs p-1"
                          >
                            <i class="mdi mdi-square-edit-outline" />
                          </button>

                          <button
                            v-if="getTipoPublicoAlvo(data.item.publico_alvo) !== false"
                            :title="$t('Listar acolhimentos')"
                            @click="getAcolhimentosUnidade(data.item)"
                            class="btn btn-success btn-xs p-1"
                          >
                            <i class="mdi mdi-format-list-bulleted-square" />
                          </button>

                          <button
                            v-if="isGestor"
                            :title="$t('Informações da Unidade')"
                            @click="informacoesUnidade(data.item.unidade_id)"
                            class="btn btn-info btn-xs p-1"
                          >
                            <i class="mdi mdi-information-outline" />
                          </button>
                        </div>
                      </template>
                      <template v-slot:empty="scope">
                        <div class="text-center my-5">
                          <img
                            :alt="$t('No results')"
                            class="mb-5"
                            src="/img/icons/robot.svg"
                            style="max-height: 165px"
                          />
                          <h3 class="bold">
                            {{ $t("No records found") }}
                          </h3>
                        </div>
                      </template>
                    </b-table>
                  </print-content>

                  <div
                    class="row align-items-center no-print"
                    v-if="itemList.length > 0"
                  >
                    <div class="col-lg-6 col-md-12">
                      <div class="form-group d-inline-flex mb-0">
                        <select
                          class="form-control"
                          style="width: 70px"
                          v-model="perPage"
                          v-on:change="getItensFromFirstPage"
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                      <div class="d-inline-flex ml-2">
                        <b-pagination
                          :per-page="perPage"
                          :total-rows="pagination.total"
                          @change="changePage"
                          v-model="page"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                      <div class="float-lg-right">
                        {{ $t("Showing page") }}
                        {{ pagination.currentPage }}
                        {{ $t("of") }}
                        {{ pagination.totalPages }}
                        {{ $t("pages in") }}
                        {{ pagination.total }}
                        {{ $t("records") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Cadastrar @submit="getMaxVagas" />
            <Editar :selected="selectedItem" @submit="getMaxVagas" />
            <SolicitacaoVagas />
            <ModalInformacoesUnidade :unidade="unidadeSelecionada" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Cadastrar from "./includes/CadastrarVagas";
import Editar from "./includes/EditarVagas";
import FiltroHeader from "./includes/FiltroHeaderUnidade";
import SolicitacaoVagas from "./includes/ModalSolicitarVaga";
import ModalInformacoesUnidade from "./includes/ModalInformacoesUnidade";

export default {
  components: { Cadastrar, Editar, FiltroHeader, SolicitacaoVagas, ModalInformacoesUnidade},
  name: "Acolhimentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Unidades Acolhimento"),
    };
  },
  data() {
    return {
      viewFilterReport: false,
      itemList: [],
      page: 1,
      search: "",
      perPage: 10,
      isGestor: false,
      loadingItens: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      user_id: null,
      selectedItem: "",
      vagas: [0, 50],
      vagasOcupadas: [0, 50],
      publicoAlvo: [],
      unidadeSelecionada: null,
    };
  },
  mounted() {
    // this.getItens();
  },
  updated() {
    if (this.$store.state.user) {
      let role_user = this.$store.state.user.role_details.name;
      this.isGestor =
        role_user == "Gestor(a)" || role_user == "Admin" ? true : false;
    }
  },
  methods: {
    openCadastrar() {
      this.$bvModal.show("cadastrar-vaga-unidade");
    },
    openSolicitarVagas() { 
      this.$bvModal.show("solicitacao-vagas");
    },
    editar(item) {
      this.selectedItem = item;
      this.$bvModal.show("editar-vaga-unidade");
    },
    informacoesUnidade(unidade_id) {
      this.unidadeSelecionada = null;

      axios
        .get(`api/dashboard/unidades/${unidade_id}`)
        .then((response) => {
          const data = response.data.data;

          const endereco = data.endereco;

          const enderecoCompleto = [
            endereco.logradouro?.nome_logradouro,
            endereco.numero_endereco,
            endereco.localidade?.nome_localidade,
            endereco.cidade?.nome,
            endereco.estado?.sigla,
            `CEP ${endereco.logradouro?.cep}`,
          ]
            .filter(Boolean)
            .join(', ');

          this.unidadeSelecionada = {
            nome: data.nome,
            telefone: data.telefone,
            endereco: enderecoCompleto,
            email: data.email,
          };

          this.$bvModal.show("modal-informacoes-unidade");
        })
        .catch(() => {
          this.$bvToast.toast("Erro ao buscar informações da unidade.", {
            title: "Erro",
            variant: "danger",
            solid: true,
          });
        });
    },
    getAcolhimentosUnidade(item) {
      let tipo = this.getTipoPublicoAlvo(item.publico_alvo);

      if (tipo == "crianca") {
        this.$router.push({
          path: `/dashboard/acolhimentos/${item.unidade_id}`,
          query: { unidade_nome: item.unidade_nome, tipo_rota: "crianca" },
        });
      } else if (tipo == "idoso") {
        this.$router.push({
          path: `/dashboard/acolhimentos/idoso/${item.unidade_id}`,
          query: { unidade_nome: item.unidade_nome, tipo_rota: "idoso" },
        });
      }
    },  
    abrirGestaoVagas() {
      this.$router.push("/dashboard/acolhimento/gestao-vagas");
    },
    setValues(publico, ocupadas, vagas, search) {
      this.publicoAlvo = publico;
      this.vagasOcupadas = ocupadas;
      this.vagas = vagas;
      this.search = search;
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/acolhimentos/unidades", {
          params: {
            page: this.page,
            search: this.search,
            vagas: this.vagas,
            vagasOcupadas: this.vagasOcupadas,
            publicoAlvo: this.publicoAlvo,
            perPage: this.perPage,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    getItens() {
      this.loading = true;
      axios
        .get("api/dashboard/acolhimentos/unidades", {
          params: {
            page: this.page,
            search: this.search,
            vagas: this.vagas,
            vagasOcupadas: this.vagasOcupadas,
            publicoAlvo: this.publicoAlvo,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getItensFromFirstPage() {
      this.page = 1;
      this.getItens();
    },
    getMaxVagas() {
      axios
        .get("api/dashboard/acolhimentos/unidades/get/vagasmaximas")
        .then((response) => {
          this.max = response.data.vagas;
          this.max_ocupadas = response.data.vagas;
          this.vagas = [0, this.max];
          this.vagasOcupadas = [0, this.max_ocupadas];
          this.getItensFromFirstPage();
        });
    },
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages) {
        this.page = page;
        this.getItens();
      }
    },
    getPublicoAlvo(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0]
        ? `<span class="badge bg-light text-dark">${result[0].value}</span>`
        : "";
    },
    getTipoPublicoAlvo(alvo) {
      if (alvo != null) {
        let tipo = false;
        for (var i = 0; i < alvo.length; i++) {
          if (alvo[i] == 1 || alvo[i] == 2 || alvo[i] == 10 || alvo[i] == 11 || alvo[i] == 12 || alvo[i] == 13 || alvo[i] == 14) {
            tipo = "crianca";
          }else{
            tipo = "idoso";
          }
        }
        return tipo;
      }
    },
  },
};
</script>
